<div class="google_recaptcha {{google_recaptcha}}">
    <div role="google_recaptcha"></div>
    <div id="google_recaptcha" class="google_recaptcha-instance"></div>
</div>